import { PageHeading } from '@/console/ui/PageHeading'
import { TABS } from '@/console/shell/tabs'
import { RepublishPanel } from './RepublishPanel'

const tab = TABS.find((t) => t.key === 'mass')!

/**
 * LOGISPRD-13362 — MASS 정산 탭. `반품 정산 재발행`(`s-mass-republish`) + `재발행 결과`(`s-mass-result`).
 *
 * `onBusyChange` 는 셸의 탭바 잠금으로 이어진다 — 재발행은 멱등이 아니라, 응답 전에 탭을 바꿔
 * 결과를 못 보면 같은 건을 다시 보내 이중청구가 날 수 있다(`FoptTab` 과 같은 이유).
 */
export const MassTab = ({ onBusyChange }: { onBusyChange?: (busy: boolean) => void }): JSX.Element => (
  <>
    <PageHeading title={tab.heading} sub={tab.sub} />
    <RepublishPanel onBusyChange={onBusyChange} />
  </>
)
